import { pointInPolygonTest } from "~/util/intersect";

type STATE_KEY = "cs" | "sk";

const STATE: {
	[key in STATE_KEY]: {
		polygon: Array<Array<string>>;
		loadData: () => Promise<any>;
	};
} = {
	cs: {
		polygon: [],
		loadData: () => import(
			/* webpackChunkName: "cspolygondata" */
			"~/util/polygonData/cs"
		),
	},
	sk: {
		polygon: [],
		loadData: () => import(
			/* webpackChunkName: "skpolygondata" */
			"~/util/polygonData/sk"
		),
	},
};

export async function loadStatePolygon(stateKey: STATE_KEY): Promise<boolean> {
	if (STATE[stateKey].polygon.length) {
		return true;
	}

	try {
		const module = await STATE[stateKey].loadData();

		/* eslint-disable-next-line */
		STATE[stateKey].polygon = module.POLYGON;

		return true;
	} catch (exc) {
		//
	}

	return false;
}

export async function isPointInStatePolygon(lon: number, lat: number, params: {
	[key in STATE_KEY]?: boolean;
}): Promise<boolean> {
	const stateKeys = Object.keys(params);
	let inPolygon = false;

	if (stateKeys.length) {
		try {
			const polygonDataLoad: Array<Promise<boolean>> = [];

			for (const key of stateKeys) {
				polygonDataLoad.push(loadStatePolygon(key as STATE_KEY));
			}

			await Promise.all(polygonDataLoad);

			for (const key of stateKeys) {
				const polygon = STATE[key].polygon;

				if (polygon.length) {
					inPolygon = pointInPolygonTest([lon, lat], polygon);

					if (inPolygon) {
						break;
					}
				}
			}
		} catch (exc) {
			/* eslint-disable no-console */
			console.log(exc);
		}
	}

	return inPolygon;
}
